const urlParams = new URLSearchParams(window.location.search);
const paramToken = urlParams.get("params");

const error_messages = {
  PSWDS_DO_NOT_MATCH: "The passwords you entered don't match.",
  INVALID_PSWD: "The password you entered is invalid. Please try again.",
  INVALID_EMAIL: "The email you entered is invalid. Please try again.",
  SERVER_ERROR:
    "It looks like our site isn't working right now. Please try again later.",
  PSWD_EXPIRED: "Password expired. Please reset the password",
  AUTHENTICATION_FAILED: "Authentication Failed",
  PSWD_POLICY:
    "The password must contain at least 8 characters and include 1 uppercase character, lowercase characters, and digit or special characters (@, #, $, %, ^, &, +, or =).",
  PSWD_TOTAL_LENGTH_OUT_OF_RANGE:
    "Your password was invalid. Try again following the rules below.",
  PSWD_DUP_SUBSTRING:
    "Your password was invalid. Try again following the rules below.",
  PSWD_RECENTLY_USED:
    "Your new password can't be any of your recently used ones. Please create a new password following the rules below.",
  INVALID_CREDENTIALS: "Your User ID or password is invalid. Please try again.",
  PSWD_NOT_ALLOWED_CHARS:
    "Your password was invalid. Try again following the rules below.",
  PSWD_NUM_OF_RULES_MATCHED_BELOW_LIMIT:
    "Your password was invalid. Try again following the rules below.",
  PSWD_LOCKED:
    "Your account has been locked after too many unsuccessful login attempts. Contact your admin to restore your account.",
  ACCOUNT_INACTIVE:
    "An unexpected error has occurred. Please contact your Client Account Manager.",
  ACCOUNT_DISABLED_AND_INVALID:
    "An unexpected error has occurred. Please contact your Client Account Manager.",
  PWD_CORRECT_BUT_EXPIRED: `Your password has expired. <mds-link href='${
    window.location.href.includes("localhost") ? "/" : "/apix_login/"
  }forgot-password/index.html?params=${paramToken}' text='Click here'></mds-link> to create a new one.`,
  PSWD_CONTAINS_NAME:
    "Your password was invalid. Try again following the rules below.",
};

export default error_messages;
